import { styled } from "styled-components";

export const PurchasedInfoTitle = styled.span`
  font-size: 18px;
  font-weight: 600;
  color: #383838;
`;
